import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

function DealDisclaimer({ deal }) {
	const { t } = useTranslation();

	const tooltip_text = deal?.post_pay ? t('PaymentHandledByProperty') : t('TotalPriceTooltipText');

	return (
		<Tooltip title={tooltip_text} placement="top" arrow>
			{deal?.post_pay ? (
				<div className="tax-included">{t('PayAtHotel')}</div>
			) : (
				<div className="tax-included-wrap">
					<div className="tax-included-text">
						{deal?.does_price_include_tax ? t('TaxIncluded') : t('MightNotIncludeTaxes')}
					</div>
					<div className={deal?.does_price_include_tax ? 'tax-included tooltip-icon' : 'tax-not-included tooltip-icon'} />
				</div>
			)}
		</Tooltip>
	);
}

DealDisclaimer.propTypes = {
	deal: PropTypes.shape({
		does_price_include_tax: PropTypes.bool,
		post_pay: PropTypes.bool,
	}).isRequired,
};

export default DealDisclaimer;
